/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
/* eslint-disable security/detect-unsafe-regex */

import React, { useContext, useState } from 'react';
import AnimatedList from '../../../../../components/Animation/AnimatedList';
import AnimatedModel from '../../../../../components/Animation/AnimatedModel';
import ConfirmationPrompt from '../../../../../components/ConfirmationPrompt';
import GlobalContext from '../../../../../components/Context/GloablContext';
import { dataService } from '../../../../../services/data.services';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import AnimatedButton from '../../../../../components/Animation/AnimatedButton';
import { formatAdjustedDate } from '../../../../../CommonMethods/formatDate';

const TableBody = ({
    tableData, 
    indexNum, 
    selectedIndex,
    setSelectedIndex,
    searchParams,
    selectedRef,
    setToastErrorMessage }) => {
    const {setToastmessage, isInactiveBranch} =  useContext(GlobalContext);
    /**
     * This function sets the confirmation state to activate or deactivate an item in a table.
     */
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [activateButtonLoading, setActivateButtonLoading] = useState(false)
    const navigate = useNavigate()
    const handleConformationClick = () => {
        setDeleteOpen(!deleteOpen)
    }

    const handelActionButton = async(indexNum) =>{
        setSelectedIndex(indexNum)  
    }


    const handleOnCLickActivate = async () => {
        setActivateButtonLoading(true);
        try {
            let body = { }
            body = {
                "status": "inactive",
            }
            let endpoint= `inventory/${tableData._id}`
            const response = await dataService.PatchAPI(body,endpoint);
            handleConformationClick();
            setActivateButtonLoading(false);
            setToastmessage(`Inventory item deactivated successfully`);

        } catch (error) {
            handleConformationClick();
            setActivateButtonLoading(false);
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
            console.error(error);
        }    }
   
    const handleStatus = (key) => {
        let val = {}
        switch (tableData?.status) {
        case "undelivered":
            val = {status : "Undelivered", img: "draft-img.svg", color : "bg-[#FFEEB0]"}
            break;
        case "delivered":
            val = {status : "Delivered", img: "successDot.svg", color : "bg-[#C5FFD5]"}
            break;
        case "partially-delivered":
            val = {status : "Partially Delivered", img: "bluedot.svg", color : "bg-[#C2DCEF]"}
            break;
        default:
            break;
        }
        return val[key]
    }


    return (
        <>
            <AnimatedList
                rowStatus={true}
                title={`View PO Details`}
                keyItem={indexNum}
                handleClick={(e) => { 
                    if (e.target.classList.contains('prevent-click')) {
                        return;
                    } else {
                        navigate(`/inventory-master/purchase-order/view-purchase-order/${encodeURIComponent(tableData._id)}?${searchParams.toString()}`)
                    }
                }}
                child={
                    <>
                        <td class="cursor-pointer text-start">{formatAdjustedDate(tableData?.po_date) || "-"}</td>
                        <td class="cursor-pointer text-start">{tableData?.po_number || "-"}</td>
                        <td class="cursor-pointer text-end">{Number(tableData?.po_amount).toFixed(2) || "-"}</td>
                        <td class="cursor-pointer text-start">{tableData?.vendor_name || "-"}</td>
                        <td class="cursor-pointer text-start">{formatAdjustedDate(tableData?.delivery_date) || "-"}</td>
                        <td class="table-cell cursor-pointer">
                            <div className='flex items-center justify-start'>
                                <div className={`w-fit rounded ${handleStatus("color")} flex items-center justify-center py-1.5 px-2 2xl:px-2.5`}>
                                    <img loading="lazy" decoding="async" src={`/images/${handleStatus("img")}`} alt="icon"/>
                                    <span class="text-f7 font-normal text-[#031624] pl-1">{handleStatus("status")}</span>
                                </div>
                            </div>
                        </td>
                        <td class="cursor-pointer prevent-click">
                            <div class="relative flex items-center justify-center prevent-click" data-te-dropdown-position="dropstart">
                                <button type='button' className="list-more-btn prevent-click" href="#"
                                    id={'3dot'+indexNum}
                                    // disabled={(userCognitoEmail === tableData.email_address) ? true : false}
                                    onClick={() =>handelActionButton(indexNum) }
                                    data-te-dropdown-toggle-ref
                                    aria-expanded="false"
                                    data-te-ripple-init
                                    // disabled={() => handelActionButton()}
                                    data-te-ripple-color="light">
                                    <img loading="lazy" decoding="async" src="/images/listAction.svg" alt="icon" class="prevent-click"/>
                                </button>
                                {selectedIndex===indexNum&& <ul ref={selectedRef} className={` ${(indexNum+2 === 10 || indexNum+1 === 10) ? (tableData?.status === "undelivered" ? 'top3' : 'top1') : ''} list-more-optns-div [&[data-te-dropdown-show]]:block prevent-click`} aria-labelledby="dropdownMenuButton2" data-te-dropdown-menu-ref>
                                    <>
                                        <li>
                                            <AnimatedButton
                                                handleClick={() => {}}
                                                // handleClick={handleEditClick}
                                                buttonName={"View Details"}
                                                id={'view_PO'}
                                                link={`/inventory-master/purchase-order/view-purchase-order/${encodeURIComponent(tableData._id)}?${searchParams.toString()}`}
                                                className="list-more-optns prevent-click" />
                                        </li>
                                        {tableData?.status === "undelivered" && !isInactiveBranch && <>
                                            <li title="Edit PO">
                                                <AnimatedButton
                                                    handleClick={() => {}}
                                                    // handleClick={handleEditClick}
                                                    buttonName={"Edit PO"}
                                                    link={`/inventory-master/purchase-order/edit-purchase-order/${tableData._id}?${searchParams.toString()}`}
                                                    className="list-more-optns prevent-click" />
                                            </li>
                                        </>}
                                        
                                    </>     
                                </ul>}
                            </div>
                        </td>
                    </>
                    
                }/>
          
            
            {deleteOpen && 
            <AnimatedModel
                Children={
                    <ConfirmationPrompt
                        handleOnCLickActivate={handleOnCLickActivate}
                        handleClose={handleConformationClick}
                        tittle= {`Deactivate Inventory Item`}
                        message = {`Are you sure you want to deactivate the inventory item ${tableData?.item_name}?`}
                        buttonName = {`Deactivate`}
                        loadingActivation={activateButtonLoading}
                    />
                }
            />  
            }
        </>
        
    );
}

export default TableBody;
